import { render, staticRenderFns } from "./buildingPlan.vue?vue&type=template&id=9c12a95e&scoped=true"
import script from "./buildingPlan.vue?vue&type=script&lang=js"
export * from "./buildingPlan.vue?vue&type=script&lang=js"
import style0 from "./buildingPlan.vue?vue&type=style&index=0&id=9c12a95e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c12a95e",
  null
  
)

export default component.exports